import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BaseModal, Button } from 'react-bootstrap';

import ProgramInfo from './ProgramInfo';

export default function SummaryModal({ programStatuses, show, onHide }) {
  return (
    <BaseModal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <BaseModal.Header closeButton>
        <BaseModal.Title>Close Program</BaseModal.Title>
      </BaseModal.Header>

      <BaseModal.Body>
        <ul>
          {programStatuses.map((status) => <ProgramInfo programStatus={status} key={status.assignment_id} />)}
        </ul>

        <footer className="text-center mt20">
          <Button
            bsStyle="primary"
            className="btn-outline width-120 mr10"
            onClick={onHide}
          >
            Close
          </Button>
        </footer>
      </BaseModal.Body>
    </BaseModal>
  );
}

SummaryModal.propTypes = {
  programStatuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
